import React, { Component } from 'react';
import { Link } from 'react-router-dom';

const TableRow = () => (
    <tr>
        <th scope="row">
            <Link to="/pedido/124">A301AC</Link>
        </th>
        <td>
            Edifício Varig
        </td>
        <td>
            João Silva
        </td>
        <td>
            3 minutos atrás
        </td>
        <td>
            R$ 2.300,00
        </td>
    </tr>
)

export default class LatestOrders extends Component {
    render () {
        return (
            <div class="card shadow mb-5">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">Últimos Pedidos</h3>
                </div>
                <div class="col text-right">
                  <Link to="/pedidos" class="btn btn-sm btn-danger">Ver todos</Link>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table align-items-center table-flush">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Protocolo</th>
                    <th scope="col">Estabelecimento</th>
                    <th scope="col">Seller</th>
                    <th scope="col">Data</th>
                    <th scope="col">Valor</th>
                  </tr>
                </thead>
                <tbody>
                  <TableRow />
                </tbody>
              </table>
            </div>
          </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Establishment/LatestOrders/index.js